<div *ngIf="isLoading" class="loader-overlay">
 <div class="sp sp-3balls"></div>
</div>